import React from 'react';
import PropTypes from 'prop-types';
const get = require('lodash/get');

const Strings = require('../../../../app/shared/Strings');
const Globals = require('../../../../app/globals');
const AssetUtil = require('../../util/asset');
const KeyboardUtil = require('../../util/keyboard');
const StringUtil = require('../../../../app/shared/StringUtil');
import AssetImage from '../common/AssetImage';
import ActivityIconGeneral from '../activity/ActivityIconGeneral';

const propTypes = {
    className: PropTypes.string,
    onSelect: PropTypes.func,
    interactable: PropTypes.bool,
    demo: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        project_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        owner_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string.isRequired,
        meta_data: PropTypes.shape({
            description: PropTypes.string,
            display_name: PropTypes.string,
            image_url: PropTypes.string,
        }).isRequired,
    }).isRequired,
};

const defaultProps = {
    className: '',
    onSelect: () => {},
    interactable: false,
};

function FeaturedDemoTile(props) {
    const actImage = get(props.demo.meta_data, 'image_url', undefined); // undefined will allow AssetImage to use the default image
    const actTitle = get(props.demo.meta_data, 'display_name', props.demo.title);
    const actDescription = get(props.demo.meta_data, 'description', '');
    return (
        <div
            className={`fdTile ${props.interactable ? 'fdTile-interactable' : ' '} ${props.className || ''}`}
            title={actTitle}
            tabIndex="0"
            role="button"
            onClick={props.onSelect}
            onKeyDown={(e)=>{if (KeyboardUtil.isSelectKey(e.keyCode)) props.onSelect()}}
        >
            <div className="fdTile--titleArea">
                <ActivityIconGeneral activity={props.demo} />
                <h2 className="fdTitle--titleAreaTitle">{actTitle}</h2>
            </div>
            <div className="fdTile--infoArea">
                <AssetImage
                    className="fdTile--infoAreaImg"
                    src={actImage}
                    aria-hidden={true}
                    alt="Custom Activity Image"
                />
                <div className="fdTile--infoAreaDesc">
                    {actDescription}
                </div>
            </div>
        </div>
    );
}

FeaturedDemoTile.propTypes = propTypes;
FeaturedDemoTile.defaultProps = defaultProps;

export default FeaturedDemoTile;